import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import { PROVIDER_ADMIN, PROVIDER_SALES_OPS, SUPER_ADMIN } from '../../config/app_config';
import OrderReport from './OrderReport';
import { getOrderMatchReport } from '../../actions/reports';

export class OrderReportContainer extends React.Component {
  static propTypes = {
    orderId: PropTypes.string.isRequired,
    orderMatchReportData: PropTypes.array.isRequired,
    orderMatchReportSeriesData: PropTypes.array.isRequired,
    orderSavedSearchData: PropTypes.array.isRequired,
    customerRecordMetadata: PropTypes.array.isRequired,
    fieldGroupsAgg: PropTypes.array.isRequired,
    getOrderMatchReportAction: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { orderId, getOrderMatchReportAction } = this.props;
    const token = storeWithExpiration.get('token');
    getOrderMatchReportAction(token, orderId);
  };

  render() {
    const {
      orderMatchReportData,
      orderMatchReportSeriesData,
      orderSavedSearchData,
      customerRecordMetadata,
      fieldGroupsAgg,
    } = this.props;
    return (
      <OrderReport
        orderMatchReportData={orderMatchReportData}
        orderMatchReportSeriesData={orderMatchReportSeriesData}
        orderSavedSearchData={orderSavedSearchData}
        customerRecordMetadata={customerRecordMetadata}
        fieldGroupsAgg={fieldGroupsAgg}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { orderId } = props.params;
  const { account, dialog, user, reports } = state;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const isSalesOp = user.get('userTypeId') === PROVIDER_SALES_OPS;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const orderMatchReport = reports.get('orderMatchReport');
  const orderMatchReportData = orderMatchReport.matchReport;
  const orderMatchReportSeriesData = orderMatchReport.seriesData;
  const orderSavedSearchData = orderMatchReport.savedSearches;
  const customerRecordMetadata = orderMatchReport.customerRecordMetadataAggs;
  const fieldGroupsAgg = orderMatchReport.fieldGroupsAggs;
  return {
    account,
    orderId,
    dialog,
    isProviderAdmin,
    isSalesOp,
    isSuperAdmin,
    orderMatchReportData,
    orderMatchReportSeriesData,
    orderSavedSearchData,
    customerRecordMetadata,
    fieldGroupsAgg,
  };
};

export default connect(
  mapStateToProps,
  {
    getOrderMatchReportAction: getOrderMatchReport,
  }
)(OrderReportContainer);
